import { useRouter } from "next/router";
import ClientSearchAutocomplete from "@/components/ClientSearchAutocomplete";

export default function SearchForm() {
	const router = useRouter();

	return (
		<ClientSearchAutocomplete
			placeholder='Cauta clienti ...'
			onSelectClient={(client) => router.push(`/client/${client.id}`)}
		/>
	);
}
